import { useTranslation } from 'react-i18next'
import { useFeatureFlag } from '@fs/zion-flags'
import { i18n } from '@fs/zion-locale'

function getABTestString(treatment) {
  const treatments = {
    ordinancesPage: '-page-test',
    ordinancesReady: '-ready-test',
    both: '-both-test',
  }
  return treatments[treatment] || ''
}

export default function useTempleLinks({ restrictedTemple }) {
  const { t } = useTranslation()
  const hideTreeLinksRussiaFlag = useFeatureFlag('home_header_hideTempleLinksRussia')
  const showTreeLinksRussiaFlag = useFeatureFlag('treeWeb_header_showTempleLinksRussia')
  const ordinancesABTest = useFeatureFlag('home_shared_ordinancesAB')
  const { isOn: showFamilyNameAssist } = useFeatureFlag('home_header_familyNameAssist')

  const templeLinks = {
    id: 'temple',
    text: t('nav.temple', 'Temple'),
    sub: [
      { id: 'reservations', text: t('nav.temple.reservations', 'My Reservations'), url: '/temple/reservations' },
      {
        id: 'family-groups',
        text: t('nav.group-reservations', 'Group Reservations'),
        url: '/temple/groups',
      },
      { id: 'shared-with-temple', text: t('nav.temple.shared', 'Shared with Temple'), url: '/temple/shared' },
      { id: 'completed', text: t('nav.temple.completed', 'Completed'), url: '/temple/completed' },
      {
        id: 'ordinances-ready',
        text: t('nav.temple.ordinances-ready', 'Ordinances Ready'),
        url: '/temple/ordinances-ready',
        abTestString: getABTestString(ordinancesABTest.treatment),
      },
      {
        id: 'family-name-assist',
        text: t('nav.temple.family-name-assist', 'Family Name Assist'),
        url: `/${i18n.language === 'zh' ? 'zh-Hant' : i18n.language}/temple/guide-me/family-name-assist`,
      },
      {
        id: 'schedule-temple-appointment',
        text: t('nav.temple.schedule-temple-appointment', 'Schedule Temple Appointment'),
        url: '/temple/appointment',
      },
    ],
  }

  templeLinks.sub = templeLinks.sub.filter((link) => {
    let keep = true

    if (
      ['reservations', 'shared-with-temple', 'completed', 'schedule-temple-appointment'].includes(link.id) &&
      restrictedTemple &&
      !showTreeLinksRussiaFlag.isOn
    ) {
      keep = false
    }

    if (['family-groups'].includes(link.id) && restrictedTemple && hideTreeLinksRussiaFlag.isOn) {
      keep = false
    }

    if (['family-name-assist'].includes(link.id) && !showFamilyNameAssist) {
      keep = false
    }

    return keep
  })

  return templeLinks
}
